<template>
  <div class="credit-note-wrap">
    <CCard class="m-auto">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(getDebitNote)">
          <CCardHeader class="grey-header">
            <CRow class="flex-flow-column">
              <CCol>
                <strong>{{$t('dbtNote.title')}}</strong>
              </CCol>
              <p class="desc">{{$t('dbtNote.desc')}}</p>
            </CRow>
          </CCardHeader>

          <CCardBody class="max-w-1100 m-auto ">
            <CRow class="ai-center">
              <CCol class="col-form-label col-xs-12 col-sm-12 col-md-12 label-none bs-input">
                <cAgent
                  agentType="null"
                  v-model="debitNote.agents"
                
                  :isMultiple="false"
                
                  rules="required"
                  :label="$t('dbtNote.slctAgnt')"
                  @input="onChangeAgent"
                />
              </CCol>
            </CRow>


              <CRow v-if="debitNote.agents!=null" >
                <div class="col-md-6">
                  <cAgentDetails :agencyDet="debitNote.agents" :isNeedAgencyType="true"/>
                </div>
                <div class="col-md-6">
                    <div v-if="balanceDetail">
                    <cAgentBalanceDetail :balanceDet="balanceDetail"/>

                    <!-- <cAgentBookingDetail :agentBookingDet="agentBookingDetail" /> -->
                     <cAgentBookingDetail v-if="isCurrChanged" :balanceDet="balanceDetail"/>
                        <div v-if="false">
                        <div class="available-credits" v-if="debitNote.agents.agenttype==2">
                            <div class="title">
                                {{$t('crdtNote.debitBalances')}}
                            </div>
                            <div class="count-ticket-wrapper box-shadow-card">
                                <div class="row" >
                                    <div class="col-md-6 col-sm-6 text-center border-right-line" v-for="(balance,index) in balanceDetail" :key="index">
                                        <div class="number"> {{balance.postpaid_runningamount|formatNumber(balance.currecycode)}}</div>
                                        <div class="title">{{balance.currecycode +' '}}</div>
                                    </div>

                                </div>
                            </div>

                            <div class="row">
                                <div >


                                </div>
                            </div>
                        </div>
                        </div>

                         <div class="available-credits" >
                            <div class="title">
                                {{$t('crdtNote.totalDueAmt')}}
                            </div>
                            <div class="count-ticket-wrapper box-shadow-card">
                                <div class="row" >
                                    <div class="col-md-6 col-sm-6 text-center border-right-line" v-for="(balance,index) in balanceDetail" :key="index">
                                        <div class="number"> {{balance.toteldueamount|formatNumber(balance.currecycode)}}</div>
                                        <div class="title">{{balance.currecycode +' '}}</div>
                                    </div>

                                </div>
                            </div>

                            <div class="row">
                                <div >


                                </div>
                            </div>
                        </div>

                        <!--                        <div v-if="debitNote.agents.agenttype==2">-->
                        <!-- <span>  {{$t('crdtNote.debitBalances')}} </span>-->
                        <!--                   <div v-for="(balance,index) in balanceDetail" :key="index">-->
                        <!--                 {{balance.currecycode +' '}}  {{balance.postpaid_runningamount|formatNumber(balance.currecycode)}}-->
                        <!--                   </div>-->
                        <!--                   </div>-->
                  </div>
<!--                  <div class="sys-topup-wrapper">-->
                  <div class="card cn-card">
<!--                    <div class="box-shadow-card">-->
                    <div class="card-body" v-if="isReCreateComp">
                      <div class="d-flex" style="margin-left: -15px;">
                        <div class="col-form-label label-none currency-wrapper">
                          <!-- <cCurrencyDropDown
                            v-model="debitNote.currency"
                            ctrlName="code"
                            ctrlCode="code"
                            :isShowCode="true"
                            :isMultiple="false"
                            :isSearchable="true"
                            :url="currencyServiceURL"
                            rules="_required"
                            :selValue="debitNote.currency"
                            :label="$t('dbtNote.slctCurncy')"
                            :defaultCurrencyCode="defaultCurrencyCode"
                          /> -->
                          <cDropDown
                  v-if="isCurrChanged"
                  v-model="debitNote.currency" 
                  :ctrlName="'code'"
                  :ctrlCode="'name'"
                  :isShowCode="false"
                  :isMultiple="false"
                  :isSearchable="true"
                  :url="currencyServiceURL"
                  rules="_required"
                  :selValue="debitNote.currency"
                  :label="$t('dbtNote.slctCurncy')"
                  @input="onSelectedCurrency"
                />
                        </div>
                        <CCol class="col-form-label current-value-50 label-none pt-17px">
                          <div >
                            <cTextInputComponent :isAmountField="true" @onBlur="formatDebitAmount(debitNote.debitAmount)"
                             @onFocus="onRemoveCurrFormat(debitNote.debitAmount)"
                              v-model="debitNote.debitAmount"
                              :name="'credit'"
                              :rules="'_required|no_space|only_numbers|no_zero|validDecimal|max:'+getMaxCharacters(debitNote.debitAmount)"
                              @input="onDataChange"
                              :placeholder="$t('dbtNote.amtPl')"
                            
                            />
                          </div>
                        </CCol>
                      </div>

                      <CRow class="ai-center">
                        <CCol class="col-form-label col-xs-12 col-sm-12 col-md-12 label-none">
                          <label>{{$t('dbtNote.bookId')}}</label>
                          <!-- <validation-provider tag="div" rules="_required" v-slot="{ errors }"> -->
                          <div class="input-group">
                            <input type="text" class="form-control m-0" v-model="debitNote.bookingId" @input="onDataChange" />
                            <div class="input-group-append">
                              <button
                                class="btn btn-success removewrap action-c-btn ml-auto min-w-unset primary-sky-btn"
                                type="button"
                                @click="toggleShowModal()"
                              >{{$t('dbtNote.search')}}</button>
                            </div>
                          </div>
                          <!-- <div  v-if="errors && errors[0]" class="invalid-feedback icon">
          <span>{{ errors[0] }}</span>
        </div>
                          </validation-provider>-->
                        </CCol>
                      </CRow>

                      <div class="ai-center">
                        <CCol class="col-form-label w-100 label-none row-cus-cd-n">
                          <div class="row">
                          <cTextInputComponent
                            v-model="debitNote.reference"
                            :name="$t('dbtNote.ref')"
                            :label="$t('dbtNote.ref')"
                             :placeholder="$t('dbtNote.referencePl')"
                             @onInput="onDataChange"
                            :maxLength="100"
                          />
                          </div>
                        </CCol>
                      </div>
                      <CRow class="text-right ai-center mt-10px">
                        <CCol>
                          <CButton
                                  color="success removewrap"
                                  type="submit"
                                  class="action-c-btn ml-auto"
                          >
                            <img src="@imgPath/img/png/debit.png" />
                            {{$t('dbtNote.dbt')}}
                          </CButton>
                        </CCol>
                      </CRow>
                    </div>
                       <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>                 

                  </div>
                </div>
              </CRow>

          </CCardBody>
        </form>
      </ValidationObserver>
    </CCard>
  
    <cAlertModal v-if="showAlertModal"
      :buttonList="buttonList"
      :status="modalStatus"
      :isShowIcon="true"
      :show="showAlertModal"
      :desc="confirmTxt"
    ></cAlertModal>
    <cReservationIdSearchModal
      v-if="showModal"
      :show="showModal"
      :buttonList="[ {name:$t('dbtNote.cancel'), func:toggleShowModal, color:'danger'},
                {name:$t('dbtNote.search'), color:'primary'},]"
      :resIdSearchData="resIdSearchData"
      :resIdSearchRequest="resIdSearchRequest"
      :isShowDataTable="isShowDataTable"
      @input="searchBooking"
      @send="getBookingId"
    ></cReservationIdSearchModal>
  </div>
</template>

<script>
import { ValidationObserver, localize } from "vee-validate";
//import { mapGetters, mapActions } from "vuex";

import {
  PATHNAME,
  COMPONENT_NAME,
  ALERT_MODAL_STATUS
} from "../../../src/util/constants";
import cTextInputComponent from "../../components/form/cTextInputComponent";
import cCurrencyDropDown from "../../components/currency/cCurrencyDropDown";
import cAlertModal from "../../components/form/cAlertModal";
import cDropDown from "../../components/form/cDropDown";
import cAgent from "../../components/form/cAgent";
import BaseConfiguration from "../../config/base";
import apiCreateDebitNote from "../../services/apiCreateDebitNote";
import cReservationIdSearchModal from "../../components/modal/cReservationIdSearchModal";
import apiSearchReservationByB2b from "../../services/apiSearchReservationByB2b";
import router, { navigate, goBack ,updateDataEdited} from "../../router/index";
//import GetCurrencyList from '../services/apiGetCurrencyLs';
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import Logger from "../../services/logger";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "../../util/apiValidate";
import { handleJWT, getErrorAlertValue,addClassToBody ,removeClassBody,getMaxCharOfAmount ,removeCurrFormat} from "../../util/util";
import SERVICE_URL from "../../config/API_DATA";
// import nb from "../../translations/validation/nb.json";
// import en from "../../translations/validation/en.json";
import cAgentDetails from "../../components/agentDetail/cAgentDetails";
import cAgentBalanceDetail from "../../components/agentDetail/cAgentBalanceDetail";
import cAgentBookingDetail from "../../components/agentDetail/cAgentBookingDetail";
import apiGetAgentDetails from "../../services/apiGetAgentDetails";
import apiGetBalanceDetail from "../../services/apiGetBalanceDetail";

// localize({
//   en: {
//     messages: en.messages.CreditNotePage
//   },
//   nb: {
//     messages: nb.messages
//   }
// });

export default {
  name: COMPONENT_NAME.DEBIT_NOTE,

  components: {
    ValidationObserver,
    //ValidationProvider,
    cTextInputComponent,
    cCurrencyDropDown,
    cAlertModal,
    cDropDown,
    cAgent,
    cReservationIdSearchModal,
    cAgentDetails,
    cAgentBalanceDetail,
    cAgentBookingDetail
  },

  data() {
    return {
      confirmTxt: null,
      buttonList: null,
      currencyServiceURL: SERVICE_URL.GET_AGENT_SELECTED_CURRENCY,
     // defaultCurrencyCode: BaseConfiguration.creditNoteDefaultCurrencyCode,
      // debitAmount: null,
      debitNote: {
        agents: null,
        //  {
        //   b2bid: null,
        //   b2bcode: null,
        //   agencyname: null,
        //   contact_city: null,
        //   isactive: true
        // },
        currency: null,
        debitAmount: null,
        reference: null,
        // bookingId: {
        //    id:null,
        //   name: null,
        // },
        bookingId: null
      },
      isReCreateComp:true,
      isCurrChanged: true,
      modalStatus: ALERT_MODAL_STATUS.SUCCESS,
      alertValue: null,
      showAlertModal: false,
      showModal: false,
      resIdSearchData: [],
      resIdSearchRequest: null,
      isShowDataTable: false,
      balanceDetail: null
      // agentBookingDetail: {
      //   ticketQueue: 24,
      //   booking: 24,
      //   pending: 24
      // }
      //confirmAlert: false,
      //successAlert: false
      //AcknowledgeAlertModal: false,
    };
  },

  methods: {
    onDataChange() {
        try {
          if(BaseConfiguration.isDebug) console.log("onDataChange");
         
          this.alertValue=null;
          updateDataEdited(true);
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.DEPOSIT,
                  "error in onDataChange",
                  err.toString(),
                  "onDataChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
        onRemoveCurrFormat(pDebitAmount) {
        try {
          if(BaseConfiguration.isDebug) console.log("onRemoveCurrFormat");
         
               this.debitNote.debitAmount= removeCurrFormat(pDebitAmount);

        } catch (err) {
                let body = Logger.buildRequest(
                 FILE_NAME.CREDIT,
                  "error in onRemoveCurrFormat",
                  err.toString(),
                  "onRemoveCurrFormat",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        
        }, 
      getMaxCharacters(pTopUpAmt) {
        try {
          if(BaseConfiguration.isDebug) console.log("getMaxCharacters");
          let retMaxValue= getMaxCharOfAmount(pTopUpAmt);
        
        return retMaxValue;
        }
    
         catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.DEBIT_NOTE,
                  "error in getMaxCharacters",
                  err.toString(),
                  "getMaxCharacters",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
    showAlert(val) {
      this.alertValue = val;
    },

     onSelectedCurrency(pCurrency) {
      try {
        this.debitNote.currency = pCurrency;
        this.formatDebitAmount(this.debitNote.debitAmount);///to format existing amount while changing currency

      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_NOTE,
          "error while emitting selected currency from cDropDown Component",
          err.toString(),
          "onSelectedCurrency",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getBookingId(id) {
      this.debitNote.bookingId = id;
      this.toggleShowModal();
    },

    toggleShowModal() {
      if (BaseConfiguration.isDebug) console.log("toggleShowModal");
      if (this.debitNote.agents.agencyname) {
        this.showAlert(null);
        this.showModal = !this.showModal;
        this.resIdSearchData = [];
        this.resIdSearchRequest = null;
      } else {
        this.showAlert(this.$t("dbtNote.agntAlert"));
      }
    },

    viewStatement() {
      this.showAlertModal = false;
      navigate(PATHNAME.DEBIT_REPORT);
    },

    async onChangeAgent(pAgent) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeAgent");
        // let retValue;
        this.isCurrChanged = false;
        this.debitNote.agents = pAgent;
        this.clearDebitNote();
        this.showAlert(null);
         if (this.debitNote.agents.b2bCompanyFinancess.length > 0) {
          this.debitNote.currency = this.debitNote.agents.b2bCompanyFinancess[0].currencycode;
          this.formatDebitAmount(this.debitNote.debitAmount);
          this.balanceDetail = await this.getBookingDetail(this.debitNote.agents.b2bid); 

        } else {
          this.debitNote.currency = null;
        }
        let that = this;
        setTimeout(function() {
          that.isCurrChanged = true;
        });
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_NOTE,
          "error in onChangeAgent",
          err.toString(),
          "onChangeAgent",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      //return retValue;
    },

    async getBookingDetail(b2bid) {
          if(BaseConfiguration.isDebug) console.log("getBookingDetail");
          
      let returnValue;
      try {
        let balanceReq = apiGetBalanceDetail.buildRequest(b2bid);
        if (balanceReq) {
          let balanceRes = await apiGetBalanceDetail.getResponse(balanceReq);
          if (VALIDATE_SUCCESS_RES(balanceRes)) {
            returnValue = balanceRes.data.data;
          } else {
            let error = getErrorMessage(balanceRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            } 
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_NOTE,
          "error in  getBookingDetail",
          err.toString(),
          " getBookingDetail()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    clearDebitNote() {
            try {
              if(BaseConfiguration.isDebug) console.log("clearDebitNote");
             // let retValue;
              this.debitNote.bookingId=null;
              this.debitNote.debitAmount = null;
              this.debitNote.reference = null;
        
            } catch (err) {
                    let body = Logger.buildRequest(
                      FILE_NAME.DEBIT_NOTE,
                      "error in clearDebitNote",
                      err.toString(),
                      "clearDebitNote",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
             // return retValue;
            }, 

    async searchBooking(search) {
      try {
        if (BaseConfiguration.isDebug) console.log("searchBooking");
        let req;
        let resIdSearchData = [];
        if (search) req = JSON.parse(JSON.stringify(search));
        let b2bid = this.debitNote.agents.b2bid;

        let resIdSearchRequest = apiSearchReservationByB2b.buildRequest(
          req,
          b2bid
        );

        if (resIdSearchRequest) {
          this.resIdSearchRequest = resIdSearchRequest;
          let searchResponse = await apiSearchReservationByB2b.getResponse(
            resIdSearchRequest
          );
          if (VALIDATE_SUCCESS_RES(searchResponse)) {
            // this.showAcknowledgeAlert();
            resIdSearchData = searchResponse.data.data;
            this.isShowDataTable = true;
          } else {
            let error = getErrorMessage(searchResponse);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
        this.resIdSearchData = resIdSearchData;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.debitNote,
          "error in searchBooking",
          err.toString(),
          "searchBooking",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    getDebitNote() {
      try {
        if (BaseConfiguration.isDebug) console.log("getDebitNote");
        //let retValue;
        this.showAlertModal = true;
        this.modalStatus = ALERT_MODAL_STATUS.INFO;
        this.buttonList = this.getButtonList(true);
        this.confirmTxt = this.getConfirmText(true);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_NOTE,
          "error in getDebitNote",
          err.toString(),
          "getDebitNote",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    async createDebitNote() {
      if (BaseConfiguration.isDebug) console.log("createDebitNote");
      try {
        let req = JSON.parse(JSON.stringify(this.debitNote));

        let debitRequest = apiCreateDebitNote.buildRequest(req);

        if (debitRequest) {
          let debitResponse = await apiCreateDebitNote.getResponse(
            debitRequest
          );
          if (VALIDATE_SUCCESS_RES(debitResponse)) {
            this.showAlertModal = false;
            this.showAcknowledgeAlert();
          } else {
            this.showAlertModal = false;
            let error = getErrorMessage(debitResponse);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
          updateDataEdited(false);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_NOTE,
          "error in  createDebitNote",
          err.toString(),
          "createDebitNote()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async showAcknowledgeAlert() {
      if (BaseConfiguration.isDebug) console.log("showAcknowledgeAlert");
      try {
        // let retValue = await this.getAgentDetailsById(this.debitNote.agents);
        // if(retValue){
        //   this.debitNote.agents = retValue;
        // }
        let retValue = await this.getBookingDetail(this.debitNote.agents.b2bid);
        if(retValue){
          this.balanceDetail = retValue;
        }
        this.showAlertModal = true;
        this.modalStatus = ALERT_MODAL_STATUS.SUCCESS;
        this.buttonList = this.getButtonList(false);
        this.confirmTxt = this.getConfirmText(false);
        
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_NOTE,
          "error in  showAcknowledgeAlert",
          err.toString(),
          "showAcknowledgeAlert()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      // setTimeout(function(){
      //     that.showAlertModal = true;
      // },100)
    },

    getButtonList(isConfirmAlert) {
      if (BaseConfiguration.isDebug) console.log("getButtonList");
      try {
        if (isConfirmAlert) {
          return [
            {
              name: this.$t("dbtNote.noBtn"),
              func: this.toggleShowAlertModal,
              color: "danger"
            },
             {
              name: this.$t("dbtNote.yesBtn"),
              func: this.createDebitNote,
              color: "success"
            },
          ];
        } else {
          return [
            {
              name: this.$t("dbtNote.viewStmt"),
              func: this.viewStatement,
              color: "primary"
            },
            {
              name: this.$t("dbtNote.okBtn"),
              func: this.navigateToDebitNote,
              color: "success"
            }
          ];
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_NOTE,
          "error in  getButtonList",
          err.toString(),
          "getButtonList()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    toggleShowAlertModal(){
                this.showAlertModal = false;
            },
            
    getConfirmText(isConfirmAlert) {
      if (BaseConfiguration.isDebug) console.log("getConfirmText");
      try {
        if (isConfirmAlert) {
            // this.$t("dbtNote.agentCode", {
            //   agntCode: this.debitNote.agents.b2bcode
            // }) +
            // " \n " +
          return (
          
            this.$t("dbtNote.confirmationMsg", {
              code: this.debitNote.currency.code,
              dbtAmt: this.$options.filters.formatNumber(this.debitNote.debitAmount,this.debitNote.currency.code),
              agncNam: this.debitNote.agents.agencyname,
               agntCode: this.debitNote.agents.b2bcode
            })
          );
        } else {
          return this.$t("dbtNote.dbtSuccess", {
            code: this.debitNote.currency.code,
            dbtAmt: this.$options.filters.formatNumber(this.debitNote.debitAmount,this.debitNote.currency.code),
            agncNam: this.debitNote.agents.agencyname
          });
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_NOTE,
          "error in  getConfirmText",
          err.toString(),
          "getConfirmText()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getAgentDetailsById(pAgencyDet) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log(" getAgentDetails");
        let getAgtDetReq = apiGetAgentDetails.buildRequest(pAgencyDet.b2bid);
        if (getAgtDetReq) {
          let getAgtDetRes = await apiGetAgentDetails.getResponse(getAgtDetReq);

          if (VALIDATE_SUCCESS_RES(getAgtDetRes)) {
            retValue = getAgtDetRes.data.data;
          }
          else {
            let error = getErrorMessage(getAgtDetRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREDIT,
          "error in getting response from GetAgentDetails API",
          err.toString(),
          "getAgentDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    navigateToDebitNote() {
      if (BaseConfiguration.isDebug) console.log(" navigateToDebitNote");
      this.showAlertModal = false;

       this.debitNote.debitAmount=null;
       this.debitNote.reference=null;
   this.debitNote.bookingId=null;
        this.isReCreateComp = false;
        let that=this;

        setTimeout(function() {
          that.isReCreateComp = true;
        });
      // this.AcknowledgeAlertModal = false;
    },

    formatDebitAmount(val) {
      if (BaseConfiguration.isDebug) console.log(" debitAmount");
      try {
        this.debitNote.debitAmount = this.$options.filters.currencyFormat(val,this.debitNote.currency.code);
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.DEBIT_NOTE,
          "",
          err.toString(),
          "debitAmount",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },
   beforeCreate() {    
   addClassToBody(COMPONENT_NAME.DEBIT_NOTE);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
};
</script>


